export default "__VITE_ASSET__ae009542__"